export default __webpack_public_path__ + "static/govnews-052333fb396ba64f88b2569d70fc30c9.png";